import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./app";
import reportWebVitals from "./reportWebVitals";

// import i18n
import "./i18n";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak";

ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      checkLoginIframe: false,
      flow: "standard",
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      enableLogging: false,
      token: localStorage.getItem("token") ?? "",
      refreshToken: localStorage.getItem("refreshToken") ?? ""
    }}
  >
    <React.StrictMode>
      <Suspense fallback={<div>Loading...</div>}>
        <App />
      </Suspense>

    </React.StrictMode>
  </ReactKeycloakProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
